import { defineComponent, h } from "vue";
import { rehype } from "rehype";
function convertCamelToKebab(str) {
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
}
function formatProperties(properties) {
  const formattedProperties = {};
  const { className, ...rest } = properties;
  formattedProperties.class = Array.isArray(className) ? className.join(" ") : "";
  Object.keys(rest).forEach((prop) => {
    const value = rest[prop];
    if (prop.startsWith("data")) {
      formattedProperties[convertCamelToKebab(prop)] = value;
    } else {
      formattedProperties[prop] = value;
    }
  });
  return formattedProperties;
}
function renderNodeChildren(node, slots) {
  return node.children?.map((n) => {
    if (n.type === "element" && n.tagName === "ssg-children") {
      const slotName = n.properties?.name;
      const slot = typeof slotName === "string" ? slots?.[slotName] : slots?.default;
      return slot?.()?.[0] ?? "";
    }
    return renderNode(n, slots);
  }).filter((v) => Boolean(v));
}
function renderNode(node, slots) {
  if (node.type === "element") {
    return h(
      node.tagName,
      formatProperties(node.properties),
      renderNodeChildren(node, slots)
    );
  }
  if (node.type === "text") {
    return node.value.trim();
  }
  return null;
}
function nestedRenderFunction(html, slots) {
  const base = getHastTreeRoot(html);
  return base?.type === "element" ? h(
    base.tagName,
    formatProperties(base.properties),
    renderNodeChildren(base, slots)
  ) : h("");
}
function toVueComponent(render, propTemplate) {
  return defineComponent({
    props: Object.keys(propTemplate),
    setup(props, { slots }) {
      return () => nestedRenderFunction(render(props), slots);
    }
  });
}
function svgToVueComponent(svg) {
  return toVueComponent(() => svg, {});
}
function getHastTreeRoot(html) {
  let node = null;
  rehype().data("settings", { fragment: true }).use(() => {
    return (tree) => {
      if (!("children" in tree && Array.isArray(tree.children))) return;
      const base = tree.children[0];
      if (base.type === "element") {
        node = base;
      }
    };
  }).processSync(html);
  return node;
}
function extractRootHtmlElement(html) {
  const root = {
    tagName: "",
    properties: {},
    innerHTML: ""
  };
  const result = rehype().data("settings", { fragment: true }).use(() => {
    return (tree) => {
      if (!("children" in tree && Array.isArray(tree.children))) return;
      const first = tree.children[0];
      if (first.type === "element") {
        root.tagName = first.tagName;
        Object.assign(root.properties, first.properties);
        tree.children = first.children;
      }
    };
  }).processSync(html).toString();
  root.innerHTML = result;
  return root;
}
export {
  extractRootHtmlElement,
  formatProperties,
  getHastTreeRoot,
  nestedRenderFunction,
  svgToVueComponent,
  toVueComponent
};
//# sourceMappingURL=component-from-string.js.map
